import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmitterService } from '../../services/emitter.service';
import { swiperGridAutoConfig } from "../../shared/utility/config";

@Component({
  selector: 'app-lobby-game-by-theme',
  templateUrl: './lobby-game-by-theme.component.html',
  styleUrls: ['./lobby-game-by-theme.component.scss']
})
export class LobbyGameByThemeComponent implements OnInit {
  @Input() tagsList;
  swiperTagConfig = swiperGridAutoConfig;
  @Input() activeTag;
  langCode;
  destroy$: Subject<boolean> = new Subject();
  constructor(
    private router: Router,
    private emitterService: EmitterService,
    private activatedRoute: ActivatedRoute
  ) {
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    }); 
  }

  ngOnInit(): void {
  }

  goToCategoryTag(tagId) {
    this.router.navigate([this.langCode + '/casino/allgames'], { queryParams: { "tagId": tagId } });
  }
}
